var _defs, _line, _path, _path2, _line2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-12 {\n            fill:none;\n            stroke:#000;\n            stroke-linecap:round;\n            stroke-width:1.5px;\n        }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M12,4H6.7a2,2,0,0,0-2,2V18a2,2,0,0,0,2,2H12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M20,7V6a2,2,0,0,0-2-2H15.59"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 20,
    y1: 14.3,
    x2: 20,
    y2: 9.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M15.59,20H18a2,2,0,0,0,2-2V17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyAction);
export default __webpack_public_path__ + "static/media/policy-action.651a2d8e6ed2730e69f89268afe74000.svg";
export { ForwardRef as ReactComponent };